import React, { useEffect, useState } from "react"
import Layout from "../components/layout"

import ModelHeader from "../content/model_detail/_sections/_model_header"
import ModelApp from "../content/model_detail/_sections/_model_app"
import ModelAdvantages from "../content/model_detail/_sections/_model_advantages"
import ModelYoutube from "../content/model_detail/_sections/_model_youtube"
import ModelCalorexDesign from "../content/model_detail/_sections/_model_calorex_design"
import ModelSystems from "../content/model_detail/_sections/_model_systems"
import ModelConocelo from "../content/model_detail/_sections/_model_conocelo"
import Storytelling from "../content/promotions/storytelling"
import { usePrismCalorexNet } from "../hooks/use_prismic_calorex-net"

import "../styles/pages/model/model.scss"

const CalentadoresNet = props => {
  const calorexNet = usePrismCalorexNet().edges
  const data = calorexNet[0].node

  const start_color = "#ba0c2f"
  const stop_color = "#d90b2d"
  const text_color = "#ba0c2f"

  const blockComponents = {
    "PrismicCalorexNetBodyYoutube": (block, index) => (
      <ModelYoutube
        key={`youtube-${index}`}
        _model={{ ...data, data: { ...data.data, body: [block] } }}
        search="PrismicCalorexNetBodyYoutube"
        className="calorex-net__model_youtube"
      />
    ),
    "PrismicCalorexNetBodyVentajas": (block, index) => (
      <ModelAdvantages
        key={`advantages-${index}`}
        _model={{ ...data, data: { ...data.data, body: [block] } }}
        search="PrismicCalorexNetBodyVentajas"
      />
    ),
    "PrismicCalorexNetBodyConoceloGrupo": (block, index) => (
      <ModelConocelo
        key={`conocelo-${index}`}
        _model={{ ...data, data: { ...data.data, body: [block] } }}
        search="PrismicCalorexNetBodyConoceloGrupo"
      />
    ),
    "PrismicCalorexNetBodySistemas": (block, index) => (
      <ModelSystems
        key={`systems-${index}`}
        _model={{ ...data, data: { ...data.data, body: [block] } }}
        search="PrismicCalorexNetBodySistemas"
      />
    ),
    "PrismicCalorexNetBodyStorytelling2": (block, index) => (
      <Storytelling
        key={`storytelling-${index}`}
        _body={[block]}
        search="PrismicCalorexNetBodyStorytelling2"
      />
    ),
    "PrismicCalorexNetBodyBannerApp": (block, index) => (
      <ModelApp
        key={`modelapp-${index}`}
        _model={{ ...data, data: { ...data.data, body: [block] } }}
        search="PrismicCalorexNetBodyBannerApp"
        title="Calorex NET"
      />
    ),
  }

  const renderDynamicBlocks = () => {
    if (!data.data.body) return null
    
    return data.data.body.map((block, index) => {
      const blockType = block.__typename
      const ComponentRenderer = blockComponents[blockType]
      
      if (ComponentRenderer) {
        return ComponentRenderer(block, index)
      }
      
      // Log para bloques no mapeados (opcional)
      console.warn(`Block not found: ${blockType}`)
      return null
    }).filter(Boolean) // Elimina nulls
  }

  return (
    <Layout _class="modeldetail">
      <style
        dangerouslySetInnerHTML={{
          __html: `.stage .main .swiper-pagination-bullet-active { border-color: ${start_color} }
                .detail_main_color { color: ${start_color} }
                .detail_version_menu_item_dash:before{ background-image: linear-gradient(${start_color} 0%, ${stop_color} 100%); }
                .pagination__dots .slick-active .pagination__bullet{ border-color: ${start_color}}
                .pagination__dots li:hover .pagination__bullet{ border-color: ${start_color}}
                .stage .main .detail_color_start{ color: ${start_color}}
                .select__family{background-image: linear-gradient(${start_color} 0%, ${stop_color} 100%);}

                .product__bg__gradient--h{background: linear-gradient(90deg, ${start_color} 0%, ${stop_color} 100%);}
                .product__bg__gradient--h{background: linear-gradient(90deg, ${start_color} 0%, ${stop_color} 100%);}
                .product__title_color{color: ${text_color} ;}
                // .detail_maintenance .access__button p{background: linear-gradient(90deg, ${start_color} 0%, ${stop_color} 100%);}
                .detail_maintenance .access__button p { animation: detail_maintenance_bg_animation_out 0.25s forwards;}
                .detail_maintenance .access__button:hover p { animation: detail_maintenance_bg_animation_in 0.25s forwards;}


                @keyframes detail_maintenance_bg_animation_in {
                    0%   { background: linear-gradient(90deg, ${start_color} 0%, ${stop_color} 100%);}
                    10%   { background: linear-gradient(90deg, ${start_color} 10%, ${stop_color} 100%);}
                    20%   { background: linear-gradient(90deg, ${start_color} 20%, ${stop_color} 100%);}
                    30%   { background: linear-gradient(90deg, ${start_color} 30%, ${stop_color} 100%);}
                    40%   { background: linear-gradient(90deg, ${start_color} 40%, ${stop_color} 100%);}
                    50%   { background: linear-gradient(90deg, ${start_color} 50%, ${stop_color} 100%);}
                    60%   { background: linear-gradient(90deg, ${start_color} 60%, ${stop_color} 100%);}
                    70%   { background: linear-gradient(90deg, ${start_color} 70%, ${stop_color} 100%);}
                    80%   { background: linear-gradient(90deg, ${start_color} 80%, ${stop_color} 100%);}
                    90%   { background: linear-gradient(90deg, ${start_color} 90%, ${stop_color} 100%);}
                    100%  { background: linear-gradient(90deg, ${start_color} 99%, ${stop_color} 100%);}
                }
                @keyframes detail_maintenance_bg_animation_out {
                    0%   { background: linear-gradient(90deg, ${start_color} 99%, ${stop_color} 100%);}
                    10%   { background: linear-gradient(90deg, ${start_color} 90%, ${stop_color} 100%);}
                    20%   { background: linear-gradient(90deg, ${start_color} 80%, ${stop_color} 100%);}
                    30%   { background: linear-gradient(90deg, ${start_color} 70%, ${stop_color} 100%);}
                    40%   { background: linear-gradient(90deg, ${start_color} 60%, ${stop_color} 100%);}
                    50%   { background: linear-gradient(90deg, ${start_color} 50%, ${stop_color} 100%);}
                    60%   { background: linear-gradient(90deg, ${start_color} 40%, ${stop_color} 100%);}
                    70%   { background: linear-gradient(90deg, ${start_color} 30%, ${stop_color} 100%);}
                    80%   { background: linear-gradient(90deg, ${start_color} 20%, ${stop_color} 100%);}
                    90%   { background: linear-gradient(90deg, ${start_color} 10%, ${stop_color} 100%);}
                    100%  { background: linear-gradient(90deg, ${start_color} 0%, ${stop_color} 100%);}
                }
                .stage .main .arrow_down path{ stroke:${start_color} }
                @supports not (-ms-high-contrast: none) {
                    .detail_conocelo_item_number_text{
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                    .detail_conocelo_item_number_bg,.detail_conocelo_item_number_text{
                        background-image: linear-gradient(${start_color},${stop_color});

                    }
                    @-moz-document url-prefix() {
                        .detail_conocelo_item_number_text {
                            -webkit-text-fill-color: ${start_color};
                        }
                      }

                }
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {

                    .detail_conocelo_item_number_bg{
                        background-color: ${start_color};

                    }
                    .detail_conocelo_item_number_text{
                        color: ${start_color};
                    }
                }

                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                    .detail_dimensions_select_container .products__change p{background: transparent; color: ${start_color};};
                }

                `,
        }}
      />
      <ModelHeader _model={data} hiddenModelMenu={true}></ModelHeader>
      {renderDynamicBlocks()}
      {data.data.calorex_design ? (
        <ModelCalorexDesign _model={data}></ModelCalorexDesign>
      ) : null}
    </Layout>
  )
}

export default CalentadoresNet
